import { render, staticRenderFns } from "./ItemSearchEx.vue?vue&type=template&id=37259b78&scoped=true&"
import script from "./ItemSearchEx.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchEx.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchEx.vue?vue&type=style&index=0&id=37259b78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37259b78",
  null
  
)

export default component.exports